<template>
  <a-modal
    :title="title"
    :width="1100"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    :okButtonProps="{ props: {disabled: disableSubmit} }"
    cancelText="关闭">

    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-row style="width: 100%;">
          <a-col :span="24/2">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="专家身份证">
              <a-input placeholder="请输入专家身份证" v-decorator="['expertCode', validatorRules.expertCode]" :readOnly="disableSubmit" :maxLength="18"/>
            </a-form-item>
          </a-col>
          <a-col :span="24/2">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="专家姓名">
              <a-input placeholder="请输入专家姓名" v-decorator="['expertName', validatorRules.expertName]" :readOnly="disableSubmit" :maxLength="20"/>
            </a-form-item>
          </a-col>
        </a-row>

        <a-row style="width: 100%;">
          <a-col :span="24/2">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="单位名称">
              <a-input placeholder="请输入专家单位名称" v-decorator="['company', validatorRules.expertName]"
                       :readOnly="disableSubmit"/>
            </a-form-item>
          </a-col>
          <a-col :span="24/2">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="专家电话">
              <a-input placeholder="请输入专家电话" type=tel v-decorator="['phone', {}]" :readOnly="disableSubmit" :maxLength="20"/>
            </a-form-item>
          </a-col>
        </a-row>

        <a-row style="width: 100%;">
          <a-col :span="24/2">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="技术职称">
              <a-input placeholder="请输入技术职称" v-decorator="['technicalTitle', {}]"
                       :readOnly="disableSubmit"/>
            </a-form-item>
          </a-col>
          <a-col :span="24/2">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="专家职务">
              <j-select-position placeholder="请选择职务" :multiple="false" v-decorator="['post', {}]"/>
            </a-form-item>
          </a-col>
        </a-row>

        <a-row style="width: 100%;">
          <a-col :span="24/2">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="通讯地址">
              <a-input placeholder="请输入通讯地址" v-decorator="['address', {}]" :readOnly="disableSubmit"/>
            </a-form-item>
          </a-col>
          <a-col :span="24/2">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="邮政编码">
              <a-input placeholder="请输入邮政编码" v-decorator="['postcode', {}]" :readOnly="disableSubmit" :maxLength="6"/>
            </a-form-item>
          </a-col>
        </a-row>

        <a-row style="width: 100%;">
          <a-col :span="24">
            <a-form-item
              :labelCol="labelColX1"
              :wrapperCol="wrapperColX1"
              label="工作简历"
              class="j-field-content">
              <j-editor v-decorator="[ 'resume', {} ]" triggerChange></j-editor>
            </a-form-item>
          </a-col>
        </a-row>

      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
  import { httpAction } from '@/api/manage'
  import { duplicateCheck } from '@/api/api'
  import pick from 'lodash.pick'
  import JDate from '@/components/fzis/JDate'
  import JEditor from '@/components/fzis/JEditor'
  import moment from 'moment'
  import JTreeSelect from '@/components/fzis/JTreeSelect'
  import JSelectPosition from '@/components/fzisbiz/JSelectPosition'

  let validatorCodeTimer = null
  export default {
    components: { JEditor, JDate, JTreeSelect, JSelectPosition },
    name: 'BoExpertsModal',
    data() {
      return {
        title: '操作',
        visible: false,
        disableSubmit: false,
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 6 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 18 }
        },
        labelColX1: {
          xs: { span: 24 },
          sm: { span: 3 }
        },
        wrapperColX1: {
          xs: { span: 24 },
          sm: { span: 21 }
        },
        confirmLoading: false,
        form: this.$form.createForm(this),
        validatorRules: {
          expertCode: { rules: [
              { required: true, message: '请输入专家身份证号码' },
              //{ min:18,max: 18, message: '长度必须是18位', trigger: 'blur' },
              {
                validator: (rule, value, callback) => {
                  console.log("value的长度："+value.toString().length)
                  if(value.toString().length==18){
                    // 函数消抖的简单实现，防止一段时间内发送多次请求
                    if (validatorCodeTimer) {
                      // 停止上次开启的定时器
                      clearTimeout(validatorCodeTimer)
                    }
                    validatorCodeTimer = setTimeout(() => {

                      var city = { 11: "北京", 12: "天津", 13: "河北", 14: "山西", 15: "内蒙古", 21: "辽宁", 22: "吉林", 23: "黑龙江 ", 31: "上海", 32: "江苏", 33: "浙江", 34: "安徽", 35: "福建", 36: "江西", 37: "山东", 41: "河南", 42: "湖北 ", 43: "湖南", 44: "广东", 45: "广西", 46: "海南", 50: "重庆", 51: "四川", 52: "贵州", 53: "云南", 54: "西藏 ", 61: "陕西", 62: "甘肃", 63: "青海", 64: "宁夏", 65: "新疆", 71: "台湾", 81: "香港", 82: "澳门", 91: "国外 " };

                      const rr = /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i
                      if(rr.test(value) && value.length==18){
                        if (!city[value.substr(0, 2)]) {
                          callback("行政区划编码错误");
                          return;
                        }
                        //加权因子
                          let weight_factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
                          // 校验位
                          let check_code = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2]
                          let idWiSum = 0
                          for(let i =0; i<17 ;i++){
                            idWiSum += value.substring(i,i+1)*weight_factor[i]
                          }
                          //计算模
                          let idMod = idWiSum % 11
                          let idLastCode = check_code[idMod]
                          if(value[17] == idLastCode){
                            //校验成功，判断身份证号码是否可用
                            duplicateCheck({
                              tableName: '`fzis-ebid-ce`.bo_experts',
                              fieldName: 'id_card_number',
                              fieldVal: value,
                              dataId: this.model.id
                            }).then((res) => {
                              if (res.success) {
                                callback()
                              } else {
                                callback(res.message)
                              }
                            }).catch(console.error)
                          } else {
                            callback(new Error('身份证最后一位校验码不正确'))
                          }
                      }else{
                        callback(new Error('身份证仅能为18位且前两位为有效行政区划代码'))
                      }
                    }, 300)
                  } else {
                    callback("身份证长度必须是18位")
                  }
                }
              }
            ] },
          expertName: { rules: [{ required: true, message: '' }] },
        },
        url: {
          add: '/ebid-ce/boExpertsApply/add',
          edit: '/ebid-ce/boExpertsApply/edit'
        },
        userType: false,
        userIds: [],
        selectedUser: [],
        disabled: false,
        msgContent: '',
        userList: [],
        imageList:[],
        uploadText: "上传附件",
        fileList:[],
      }
    },
    created() {
    },
    methods: {
      add() {
        this.edit({})
      },
      edit(record) {
        this.form.resetFields()
        this.model = {}
        this.disable = false
        this.visible = true
        this.model = Object.assign({}, record)
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model, 'expertCode', 'expertName', 'post', 'postcode', 'address', 'resume', 'technicalTitle', 'phone', 'company'))
        })
      },
      close() {
        this.$emit('close')
        this.selectedUser = []
        this.visible = false
      },
      handleOk() {
        const that = this
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true
            let httpurl = ''
            let method = ''
            let formData = Object.assign(this.model, values)
            if (!this.model.id) {
              httpurl += this.url.add
              method = 'post'
              //formData.sysOrgCode = this.$store.getters.userInfo.orgCode;
            } else {
              httpurl += this.url.edit
              method = 'put'
            }
            if (this.userType) {
              formData.userIds = this.userIds
            }
            if(that.imageList != ''){
              formData.picUrl = that.imageList;
            }else{
              formData.picUrl = null;
            }

            console.log(that.fileList);

            if(that.fileList != ''){
              console.log("--------------")
              formData.filesUrl = that.fileList;
            }else{
              formData.filesUrl = null;
            }
            httpAction(httpurl, formData, method).then((res) => {
              if (res.success) {
                that.$message.success(res.message)
                that.$emit('ok')
                that.resetUser()
              } else {
                that.$message.warning(res.message)
              }
            }).finally(() => {
              that.confirmLoading = false
              that.close()
            })

          }
        })
      },
      handleCancel() {
        this.visible = false
        this.$emit('close')
      },
      startTimeValidate(rule, value, callback) {
        let endTime = this.form.getFieldValue('endTime')
        if (!value || !endTime) {
          callback()
        } else if (moment(value).isBefore(endTime)) {
          callback()
        } else {
          callback('开始时间需小于结束时间')
        }
      },
      endTimeValidate(rule, value, callback) {
        let startTime = this.form.getFieldValue('startTime')
        if (!value || !startTime) {
          callback()
        } else if (moment(startTime).isBefore(value)) {
          callback()
        } else {
          callback('结束时间需大于开始时间')
        }
      }
    }
  }
</script>

<style scoped>

</style>